export const projectTop = [
  { name: "トップ", link: "/dashboard", icon: "top" },
  { name: "生成状況を確認する", link: "/generate-status", icon: "document" },
  { name: "議事録", link: "/summary", icon: "document" },
  { name: "ナレッジ", link: "/knowledge", icon: "lightbulb" },
];

export const systemProposalItems = [
  { name: "システム概要書", type: "system-proposal", icon: "document" },
  { name: "概算工数見積もり", type: "estimation", icon: "table" },
  { name: "費用対効果", type: "cost-effectiveness", icon: "chart" },
];

export const requirementItems = [
  { name: "機能要件書", type: "functional-requirements", icon: "table" },
  { name: "非機能要件書", type: "non-functional-requirements", icon: "table" },
  { name: "業務フロー図", type: "workflow", icon: "chart" },
  { name: "プラグイン提案書", type: "plugin-proposal", icon: "table" },
];

export const designItems = [
  { name: "アプリ設計書", type: "app-design", icon: "document" },
  { name: "フィールド設計書", type: "field-design", icon: "table" },
  { name: "システム構成図", type: "system-architecture", icon: "chart" },
  { name: "ER図", type: "entity-relationship", icon: "chart" },
  { name: "カスタマイズ仕様書", type: "customize-specification", icon: "table" },
];

export const developmentItems = [
  { name: "アプリ生成", type: "app-generation", icon: "kintone" },
  { name: "リバースエンジニアリング", type: "reverse-engineering", icon: "reverse" },
];
